// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { baseGridHiddenProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

export interface AccountLayoutProps extends ExpandStyles<AccountLayoutStyles> {
    id: string;
}

export interface AccountLayoutStyles {
    container?: GridContainerProps;
    leftColumn?: GridItemProps;
    rightColumn?: GridItemProps;
}

export const accountLayoutStyles: AccountLayoutStyles = {
    container: baseGridHiddenProps.container,
    leftColumn: baseGridHiddenProps.sideColumn,
    rightColumn: baseGridHiddenProps.mainColumn,
};

const AccountLayout: FC<AccountLayoutProps> = ({ id, extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(accountLayoutStyles, extendedStyles, overridedStyles);

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumn}>
                <Zone contentId={id} zoneName="Side" />
            </GridItem>
            <GridItem {...styles.rightColumn}>
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
        </GridContainer>
    );
};

export default AccountLayout;
